
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class LayoutMenuButton extends Vue {
  @Prop({ required: true }) to!: string;
}
